import { render, staticRenderFns } from "./MobileNavigationNovalisCircle.vue?vue&type=template&id=376532d8&"
import script from "./MobileNavigationNovalisCircle.vue?vue&type=script&lang=js&"
export * from "./MobileNavigationNovalisCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports